// Import all custom components modules

// Core components (header, footer, text, etc.)
import "./core/index.ts";

// Offers components
import "./offers/index.ts";

// Showcase components
import "./showcase/index.ts";

// Checklist components
import "./checklist/index.ts";

// Force inclusion in bundle
console.log("All component modules loaded");
